import { Quill } from 'react-quill';

const Delta = Quill.import('delta');
const BaseTooltip = Quill.import('ui/tooltip');
class CustomQuillTooltip extends BaseTooltip {

  onRemoveHandler = (event) => {
    const range = this.quill.getSelection();
    let contents = this.quill.getContents(range.index, range.length);
    this.restoreFocus();

    let changes = new Delta().retain(range.index).delete(range.length);
    contents.ops.forEach(item => {
      if (item.insert.mention) {
        changes = changes.insert(
          Object.assign({}, item.insert, {
            mention: Object.assign({}, item.insert.mention, {
              link: false,
            }),
          }),
          Object.assign({}, item.attributes, {
            link: false,
          }),
        );
      } else {
        changes = changes.insert(
          item.insert,
          Object.assign({}, item.attributes, {
            link: false,
          }),
        );
      }
    });
    console.log({ changes });
    this.quill.updateContents(changes, Quill.sources.USER);

    event.preventDefault();
    this.hide();
  }

  restoreFocus = () => {
    const scrollTop = this.quill.scrollingContainer.scrollTop;
    this.quill.focus();
    this.quill.scrollingContainer.scrollTop = scrollTop;
  }

  customStyle() {
    this.root.classList.add('ql-custom-tooltip');

    this.root.querySelector('.ql-remove').addEventListener('click', this.onRemoveHandler);
  }
}

CustomQuillTooltip.TEMPLATE = ['<a class="ql-preview" rel="noopener noreferrer" target="_blank" href="about:blank"></a>', '<a class="ql-remove"></a>'].join('');

export default CustomQuillTooltip;